import React from "react";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "18763929056";

const WhatsAppFab = () => (
    <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
            "Hola! Quiero hacer un pedido."
        )}`}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-fab"
        className="fixed bottom-6 right-6 z-30 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebd5a] shadow-2xl flex items-center justify-center text-white transition-transform hover:scale-110"
        aria-label="WhatsApp"
    >
        <MessageCircle className="w-6 h-6" />
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-leaf-400 rounded-full animate-ping" />
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-leaf-500 rounded-full" />
    </a>
);

export default WhatsAppFab;
